import { Col, ColProps } from 'react-bootstrap';

import { FunctionComponent } from 'react';

const BreakSection: FunctionComponent<ColProps> = ({ children, title, ...rest }) => {
  return <Col {...rest}></Col>;
};

export default BreakSection;
